import { component, prop } from '../../../decorators';

import l10n from '../../../transformers/l10n';

import last from 'lodash/last';
import first from 'lodash/first';

@component
export default class TimedataSwitcher {
   @prop({ type: [String, Number], required: true }) label
   @prop({ type: Array, required: true }) timedata
   @prop({ type: Number, required: true }) currentTime
   @prop({ type: Boolean, default: false }) isTransparent

   get sorted() {
      return this.timedata.sort((t1, t2) => {
         return t1.tcIn > t2.tcIn ? 1 : -1; // eslint-disable-line no-magic-numbers
      });
   }

   get hasTimedata() {
      return !!this.timedata.length;
   }

   get title() {
      return this.hasTimedata && !this.isTransparent ? `${this.label} (${this.timedata.length})` : this.label;
   }

   get backwardTitle() {
      return l10n('switcher.backward');
   }

   get forwardTitle() {
      return l10n('switcher.forward');
   }

   timeupdate(time) {
      this.$emit('timeupdate', time);
   }

   toNext() {
      const currentTime = Math.ceil(this.currentTime);
      let [ td ] = this.sorted.filter(td => td.tcIn > currentTime);
      td = td || last(this.sorted);
      this.timeupdate(td.tcIn);
   }

   toPrev() {
      const { currentTime } = this;
      const previous = this.sorted.filter(td => td.tcOut < currentTime);
      const td = last(previous) || first(this.sorted);
      this.timeupdate(td.tcIn);
   }
}
